var _rect, _text, _text2, _text3, _line, _text4, _line2, _text5, _line3, _path, _text6, _rect2, _text7, _text8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckExample(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 140",
    role: "img",
    "aria-label": "Example check. The account number is the highlighted group of numbers along the bottom edge.",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 344,
    height: 124,
    rx: 10,
    fill: "#f7f9fc",
    stroke: "#c9d4e3",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 28,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fill: "#94a3b8"
  }, "YOUR NAME")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 39,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 8,
    fill: "#b8c2d0"
  }, "123 Main St")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 302,
    y: 28,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 8,
    fill: "#b8c2d0"
  }, "DATE")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 286,
    y1: 32,
    x2: 336,
    y2: 32,
    stroke: "#dde5ef",
    strokeWidth: 1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 58,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fill: "#94a3b8"
  }, "PAY TO THE ORDER OF")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 58,
    x2: 336,
    y2: 58,
    stroke: "#dde5ef",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 82,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#1d74ec",
    textAnchor: "middle"
  }, "Account number")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 172,
    y1: 88,
    x2: 172,
    y2: 101,
    stroke: "#1d74ec",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172 105 l-5 -9 l10 0 z",
    fill: "#1d74ec"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 122,
    fontFamily: "'Courier New', Courier, monospace",
    fontSize: 14,
    fill: "#64748b"
  }, "123456789")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 108,
    width: 104,
    height: 18,
    rx: 4,
    fill: "#1d74ec",
    fillOpacity: 0.12,
    stroke: "#1d74ec",
    strokeWidth: 1.3
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 122,
    fontFamily: "'Courier New', Courier, monospace",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#1d74ec"
  }, "0001234567")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 122,
    fontFamily: "'Courier New', Courier, monospace",
    fontSize: 14,
    fill: "#64748b"
  }, "1001")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckExample);
export default __webpack_public_path__ + "static/media/check_example.2254b8ffc060da87ddda405c864c39d4.svg";
export { ForwardRef as ReactComponent };